import { FC, useContext } from 'react'
import { Button } from '../components/button/Button'
import { AppContext } from '../AppContext'
import './LandingHeroSelectButton.scss'
import { logger } from '../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

export const LandingHeroSelectButton: FC = () => {
  const { setUploadOpened } = useContext(AppContext)

  return (
    <Button
      className="LandingHeroSelectButton"
      onClick={() => {
        logger.log(LogActionType.LandingSelectFileButtonClick)

        setUploadOpened(true)
      }}
    >
      Select audio file
    </Button>
  )
}
